import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { PlanningsDeliveryEntity, PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';
import {
  ShiftTruckFixedStatusUpdateRequest,
} from 'src/entities/ShiftTruckFixedStatus.entity';

import { usePlanningsDeliveriesCache, usePlanningsDeliveriesWithLegRunsCache } from './usePlanningsCache';

export const useMutationShiftTruckFixedStatus = () => {
  const deliveryCache = usePlanningsDeliveriesCache();

  return useMutation({
    mutationFn: async (request: ShiftTruckFixedStatusUpdateRequest): Promise<PlanningsDeliveryEntity[]> => {
      const response = await axios.put<PlanningsDeliveryEntity[]>(
        '/api/v3/shift_trucks/bulk/fixed_status_update',
        request
      );
      return response.data;
    },
    onSuccess(data) {
      deliveryCache.updateDeliveries(data);
    },
  });
};

export const useMutationShiftTruckFixedStatusV5 = () => {
  const deliveryCache = usePlanningsDeliveriesWithLegRunsCache();

  return useMutation({
    mutationFn: async (request: ShiftTruckFixedStatusUpdateRequest): Promise<PlanningsDeliveryWithLegRunEntity[]> => {
      const response = await axios.put<PlanningsDeliveryWithLegRunEntity[]>(
        '/api/v5/plannings/fixed_status_update',
        request
      );
      return response.data;
    },
    onSuccess(data) {
      deliveryCache.updateDeliveries(data);
    },
  });
};
